import * as React from 'react';

import { pageDate } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import Image from 'lib/image-container';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

import PageSection from 'components/page/page-section';

type GlobalDatingTrendsHeroBlockContainerProps = {
  title?: string;
};

export const GlobalDatingTrendsHeroBlockContainer: React.FC<
  GlobalDatingTrendsHeroBlockContainerProps
> = (props) => {
  const internalProps = {
    title: pageDate.lxPageDateHeroBlockTitle,
    backgroundImageSrcPortrait: `${CdnImagePath}/landing/assets/photos/global-dating-trends-hero-portrait.jpg`,
    backgroundImageSrcLandscape: `${CdnImagePath}/landing/assets/photos/global-dating-trends-hero-landscape.jpg`,
    alt: props.title || '',
  };
  const isMobile = useMediaQuery(MediaQueryWidth['navigation-full']);

  return (
    <PageSection extraClass="page__section--hero-half-height page__section--max-width">
      <div
        className="page__section-inner-image"
        style={{
          position: 'relative',
          overflow: 'hidden',
          maxHeight: 'var(--max-height)',
          minHeight: 'var(--min-height)',
        }}
      >
        <Image
          src={
            !isMobile
              ? internalProps.backgroundImageSrcLandscape
              : internalProps.backgroundImageSrcPortrait
          }
          alt={internalProps.alt}
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
    </PageSection>
  );
};
